// Variante VISUELLE du dash (18/07, retour Claude-Alain : « plusieurs designs différents qui se
// produisent de manière aléatoire ») : un tirage PAR DASH, déterministe depuis l'état partagé —
// dashUntil (tick de fin, unique par dash) + index du coureur — donc identique sur tous les
// clients, en rejeu et à travers les snapshots ; JAMAIS de Math.random côté rendu.
// La mécanique (2 ticks de charge + 3 cases) et le son C cristal ne varient jamais : seul
// l'HABILLAGE change. 3 designs de la maquette /pages/dash-magie.html (choix Claude-Alain 22/07).
// Testé par tests/dash-variantes.test.ts.
export type DashVariant = 0 | 1 | 2 // 0 Comète de cristal · 1 Éclair d'arcane · 2 Onde tonnerre

export function dashVariant(dashUntil: number, idx: number): DashVariant {
  let h = (Math.imul(dashUntil, 2654435761) + idx * 40503 + 7) >>> 0
  h = (h ^ (h >>> 13)) >>> 0
  h = Math.imul(h, 1274126177) >>> 0
  return ((h >>> 8) % 3) as DashVariant
}
